module.exports = __webpack_public_path__ + "img/car-1.6e972056.jpg";